module.exports = __webpack_public_path__ + "media/images/pokerroom/lotos/step2-pict02-fef9ac34bfeb9c173be662665e105200.jpg";